import React from 'react';
import * as Ui from './styles';
import { TrashIcon } from '../../../Icons';

/**
 * Componente de item de menu, que serve de gatilho
 * para a configuração de resultados de um card
 */
function ResultConfigurationMenu({
  /**
   * Titulo a ser exibido no menu
   */
  title = 'Configurações',
  /**
   * Titulo de hover do menu
   */
  hoverTitle = 'Configurar resultados',
  /**
   * Callback para click no menu
   */
  onConfigClick,
  /**
   * others
   */
  ...props
}) {
  // props from styled-components
  const { className } = props;

  function onClick() {
    if (onConfigClick) onConfigClick()
  }

  return (
    <Ui.Container withSettings={true} className={className} onClick={onClick} title={hoverTitle}>
      <Ui.IconContainer>
        <TrashIcon className="icon" color="#610082" />
      </Ui.IconContainer>
      <span>{title}</span>
    </Ui.Container>
  );
}

export default ResultConfigurationMenu;
